// extracted by mini-css-extract-plugin
var _1 = "TableConfigModal-modulecheckbox__b2xVl";
var _2 = "TableConfigModal-modulecheckboxIcon__LetWE";
var _3 = "TableConfigModal-modulecheckboxLabel__LQtOP";
var _4 = "TableConfigModal-modulecontent__t0H_o";
var _5 = "TableConfigModal-moduledisabled__mpl0X";
var _6 = "TableConfigModal-moduledrag__DCz2h";
var _7 = "TableConfigModal-moduledragIcon__R4RA6 IconNG-moduleiconContainer__SxWZ0";
var _8 = "TableConfigModal-moduleselectAll__Oe1Gy";
export { _1 as "checkbox", _2 as "checkboxIcon", _3 as "checkboxLabel", _4 as "content", _5 as "disabled", _6 as "drag", _7 as "dragIcon", _8 as "selectAll" }
